import React, { useEffect, useRef, useState } from "react";
import "./Empower.css";
import heroImg from "../../assets/images/empower-img.jpg";

const Empower = () => {
  const [start, setStart] = useState(false);

  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const sec = document.querySelector(".count-section");
      if (!sec) return;

      if (sec.getBoundingClientRect().top < window.innerHeight - 100) {
        setStart(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // SUPER FAST COUNTER (requestAnimationFrame)
  const FastCounter = ({ end }) => {
    const [num, setNum] = useState(0);
    const ref = useRef(0);

    useEffect(() => {
      if (!start) return;

      const duration = 1500; // 1.5 second fast counting
      const startTime = performance.now();

      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const value = Math.floor(progress * end);

        setNum(value);

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    }, [start]);

    return num;
  };

  return (
    <>
      {/* HERO SECTION */}
      <section className="empower-section">
        <img src={heroImg} className="empower-bg" alt="hero" />
        <div className="bg-overlay"></div>

        <div className="empower-content show right-side">
          <h1>
            Empower Your
            <br /> Future with Our
            <br /> Expertise
          </h1>
          <a href="/contact">
          <button className="empower-btn">Get Started</button>
          </a>
        </div>
      </section>
    </>
  );
};

export default Empower;
